/* Pure state helpers shared by the PDP and its regression tests. */
(function(root){
  const api={
    route(page,panel,max,anchor,delta){
      max=Math.max(0,max);panel=Math.min(max,Math.max(0,panel));
      if(delta>0){
        const before=Math.min(delta,Math.max(0,anchor-page));page+=before;delta-=before;
        if(page<=anchor+1){const inside=Math.min(delta,max-panel);panel+=inside;delta-=inside;}
        page+=delta;
      }else{
        let remaining=-delta;
        const after=Math.min(remaining,Math.max(0,page-anchor));page-=after;remaining-=after;
        if(page>=anchor-1||panel>0){const inside=Math.min(remaining,panel);panel-=inside;remaining-=inside;}
        page=Math.max(0,page-remaining);
      }
      return {page,panel};
    },
    remaining(rule={},inCart=0){
      const increment=Number(rule.increment)||1,min=Number(rule.min)||1;
      return {min:inCart>=min?increment:Math.max(increment,min-inCart),increment,max:rule.max==null?null:Math.max(0,Number(rule.max)-inCart)};
    },
    quantity(value,rule={}){
      const min=Number(rule.min)||1,step=Number(rule.increment)||1;
      const max=rule.max==null?Infinity:Number(rule.max);
      let n=Number(value);if(!Number.isFinite(n))n=min;
      n=Math.max(min,Math.min(max,n));return Math.max(min,min+Math.floor((n-min)/step)*step);
    },
    memberPrice(amount,member,eligible){
      if(!Number.isSafeInteger(amount)||amount<0)return null;
      return member===true&&eligible===true?Math.round(amount*0.8):amount;
    },
    primeComparison(amount){
      if(!Number.isSafeInteger(amount)||amount<0)return null;
      const member=Math.round(amount*0.8);
      return {regular:amount,member,benefit:amount-member};
    },
    price(variant,quantity,plan){
      if(!variant)return null;
      if(plan){const a=variant.selling_plan_allocations?.find(a=>String(a.selling_plan_id)===String(plan));return a?a.price:null;}
      let price=variant.price;
      for(const b of [...(variant.quantity_price_breaks||[])].sort((a,b)=>a.minimum_quantity-b.minimum_quantity)){if(quantity>=b.minimum_quantity)price=b.price;}
      return price;
    }
  };
  if(typeof module!=='undefined'&&module.exports)module.exports=api;else root.ParkPDPCore=api;
})(typeof window!=='undefined'?window:globalThis);
